import ColorStyles from '@components/ColorStyles';
import BrDropdownMultiSelectMenu from './BrDropdownMultiSelectMenu';

BrDropdownMultiSelectMenu.ColorStyles = ColorStyles;
export default BrDropdownMultiSelectMenu;
